import LoadingModal from '@components/atoms/modals/LoadingModal';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();

const ProfilePage = lazy(() => import('../pages/profile/ProfilePage'));
const BankDetailsPage = lazy(() => import('../pages/profile/BankDetailsPage'));
const PersonalDetailsPage = lazy(
    () => import('../pages/profile/PersonalDetailsPage')
);
const TransactionHistory = lazy(
    () => import('../pages/profile/TransactionHistory')
);
const TransactionDetails = lazy(
    () => import('../pages/transactions/TransactionDetails')
);
const InvestorStatements = lazy(
    () => import('../pages/profile/InvestorStatements')
);
const Dashboard = lazy(() => import('@pages/dashboard/Dashboard'));

const Portfolio = lazy(() => import('@pages/profile/Portfolio'));

const BankDetailsForm = lazy(() => import('@pages/profile/BankDetailsForm'));
const PayoutSettings = lazy(() => import('@pages/profile/PayoutSettings'));
const SupportPage = lazy(() => import('@pages/help/SupportPage'));

const ProfileRoutes = (
    <>
        <Route
            index
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Dashboard />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.HOME }}
        />
        <Route
            path="/profile"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <ProfilePage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.PROFILE }}
        />
        <Route
            path="/profile/details"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <PersonalDetailsPage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.PROFILE_PERSONAL_DETAILS }}
        />
        <Route
            path="/profile/transactions"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <TransactionHistory />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.TRANSACTION_HISTORY }}
        />
        <Route
            path="/profile/transactions/:id"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <TransactionDetails />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.TRANSACTION_DETAILS }}
        />
        <Route
            path="/profile/statements"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <InvestorStatements />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.INVESTOR_STATEMENTS }}
        />
        <Route
            path="/profile/portfolio"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Portfolio />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.MY_PORTFOLIO }}
        />
        <Route
            path="/profile/bank-details-form"
            element={
                <ProtectedRoute
                    accountStatus={['KycVerified']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BankDetailsForm />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.BANK_FORM_1 }}
        />
        <Route
            path="/profile/bank-details"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <BankDetailsPage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.PROFILE_BANK_DETAILS }}
        />
        <Route
            path="/profile/payout-settings"
            element={
                <ProtectedRoute
                    accountStatus={['Complete']}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <PayoutSettings />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.PAYOUT_SETTINGS }}
        />
        <Route
            path="/support"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <SupportPage />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.SUPPORT }}
        />
    </>
);

export default ProfileRoutes;
